import React from "react";
import Hero from "../components/landing/Hero";
import Experience from "../components/landing/Experience";
import Features from "../components/landing/Features";
import Benefits from "../components/landing/Benefits";
import Exchange from "../components/landing/Exchange";
import CTA from "../components/landing/CTA";

function LandingPage() {
    return (
        <>
            <Hero />
            <Experience />
            {/*<section className="decentralized-future section-padding">*/}
            {/*    <div className="w-layout-blockcontainer container w-container">*/}
            {/*        <div data-w-id="c9f99673-089d-a669-a327-5c70c8fce95c" */}
            {/*             className="content-wrapper future">*/}
            {/*            <div className="section-title">*/}
            {/*                <p className="label">DECENTRALIZED FUTURE</p>*/}
            {/*                <div className="title">*/}
            {/*                    <h2 className="heading-2 _680px">Empower Your Digital Experience with Web3Go</h2>*/}
            {/*                    <p className="body-text-16 _480">*/}
            {/*                        Experience the Future of the Internet with Secure,<br/>*/}
            {/*                        Transparent, and Decentralized Solutions<br/>*/}
            {/*                    </p>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="future-wrapper">*/}
            {/*                <div className="single-future-card stoke">*/}
            {/*                    <div className="future-content-wrapper">*/}
            {/*                        <div className="section-title left-20px">*/}
            {/*                            <p className="label">MULTI-CHAIN INTEGRATION</p>*/}
            {/*                            <div className="title">*/}
            {/*                                <h3 className="heading-3">Seamless Multi-Chain Integration</h3>*/}
            {/*                                <p className="body-text-16">Effortlessly Access and Engage with Multiple*/}
            {/*                                    Blockchains, enabling users to connect across diverse ecosystems.</p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                        <div className="line"></div>*/}
            {/*                        <div className="future-image-wrapper">*/}
            {/*                            <img*/}
            {/*                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66debdcb4d9cb273a670317c_arrow%20(1).png"*/}
            {/*                                loading="lazy" alt="" className="future-image"/>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="single-future-card stoke">*/}
            {/*                    <div className="future-content-wrapper">*/}
            {/*                        <div className="section-title left-20px">*/}
            {/*                            <p className="label">AI-DEIVEN INSIGHTS</p>*/}
            {/*                            <div className="title">*/}
            {/*                                <h3 className="heading-3">Leverage AI- for Informed Decision</h3>*/}
            {/*                                <p className="body-text-16">Access and Interact with Multiple Blockchains*/}
            {/*                                    Effortlessly allowing users to explore and interact with various*/}
            {/*                                    ecosystems.</p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                        <div className="line"></div>*/}
            {/*                        <div className="future-image-wrapper-2">*/}
            {/*                            <img*/}
            {/*                                src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66debdcba27a9a8975c4ca5f_sphere%20(1).png"*/}
            {/*                                loading="lazy" alt="" className="future-image"/>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}
            <Features />
            <Benefits />
            <Exchange />
            <CTA />
        </>
    )
}

export default LandingPage;